module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('center', [_c('ul', _vm._l((_vm.routes), function(route) {
    return (route.title) ? _c('li', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(route.path)
        }
      }
    }, [_vm._v(_vm._s(route.title))])]) : _vm._e()
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59d29f16","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/nav.vue
// module id = 45
// module chunks = 0